import { NEWLINE } from '@/config/common';
import {
  PRICE_PLAN_GROUP_REQUEST,
  PRICE_PLAN_GROUP_SUCCESS,
  PRICE_PLAN_GROUP_ERROR,
  PRICE_PLAN_ASSOCIATION_REQUEST,
  PRICE_PLAN_ASSOCIATION_SUCCESS,
  PRICE_PLAN_ASSOCIATION_ERROR,
  ADDON_GROUP_REQUEST,
  ADDON_GROUP_SUCCESS,
  ADDON_GROUP_ERROR,
  EQUIPMENT_DETAILS_REQUEST,
  EQUIPMENT_DETAILS_SUCCESS,
  EQUIPMENT_DETAILS_FAILURE,
  SERVICE_NUMBER_REQUEST,
  SERVICE_NUMBER_SUCCESS,
  SERVICE_NUMBER_FAILURE,
  DEVICE_BRANDS_ERROR,
  DEVICE_BRANDS_REQUEST,
  DEVICE_BRANDS_SUCCESS,
  GET_MOBILE_SHARE_REQUEST,
  GET_MOBILE_SHARE_SUCCESS,
  GET_MOBILE_SHARE_ERROR,
  GET_MOBILE_SHARE_ELIGIBILITY_REQUEST,
  GET_MOBILE_SHARE_ELIGIBILITY_SUCCESS,
  GET_MOBILE_SHARE_ELIGIBILITY_ERROR,
  GET_DEVICES_BY_PLAN_GROUP_ERROR,
  GET_DEVICES_BY_PLAN_GROUP_REQUEST,
  GET_DEVICES_BY_PLAN_GROUP_SUCCESS,
  GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST,
  GET_SMART_TEMPLATE_LIST_DETAILS_FAILURE,
  GET_SMART_TEMPLATE_LIST_DETAILS_SUCCESS,
  GET_SMART_TEMPLATE_MENU_REQUEST,
  GET_SMART_TEMPLATE_MENU_SUCCESS,
  GET_SMART_TEMPLATE_MENU_FAILURE,
  UPDATE_SMART_TEMPLATE_NAME_REQUEST,
  UPDATE_SMART_TEMPLATE_NAME_SUCCESS,
  UPDATE_SMART_TEMPLATE_NAME_FAILURE,
  DELETE_SMART_TEMPLATE_REQUEST,
  DELETE_SMART_TEMPLATE_SUCCESS,
  DELETE_SMART_TEMPLATE_FAILURE,
  GET_CHECK_RESERVE_FAILURE,
  GET_CHECK_RESERVE_REQUEST,
  GET_CHECK_RESERVE_SUCCESS,
  GET_RESERVED_STOCKS_FAILURE,
  GET_RESERVED_STOCKS_REQUEST,
  GET_RESERVED_STOCKS_SUCCESS,
  GET_SMART_TEMPLATE_BY_ID_FAILURE,
  GET_SMART_TEMPLATE_BY_ID_REQUEST,
  GET_SMART_TEMPLATE_BY_ID_SUCCESS,
  GET_NUMBER_POOL_BILL_ACC_FAILURE,
  GET_NUMBER_POOL_BILL_ACC_REQUEST,
  GET_NUMBER_POOL_BILL_ACC_SUCCESS,
  GET_CHECKOUT_NUMBER_POOL_BILL_ACC_FAILURE,
  GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST,
  GET_CHECKOUT_NUMBER_POOL_BILL_ACC_SUCCESS,
  GET_NUMBER_POOL_EXISTING_BILL_ACCOUNT,
  GET_BUNDLEDADDONS_FOR_PRICEPLAN_ERROR,
  GET_BUNDLEDADDONS_FOR_PRICEPLAN_REQUEST,
  GET_BUNDLEDADDONS_FOR_PRICEPLAN_SUCCESS,
  SELECTED_PLAN,
  GET_DEP_RESELLER_ID_REQUEST,
  GET_DEP_RESELLER_ID_SUCCESS,
  GET_DEP_RESELLER_ID_ERROR
} from './actionTypes';
import {
  DevicePlanGroupRequest,
  IUpdateSmartTemplateName,
  IDeleteSmartTemplate,
  IgetEquipmentDetails,
  IPlan
} from './models/types';

export const getPricePlanGroup = {
  request: (shoppingCartType = NEWLINE, transfereeOfBrn = "") => ({
    type: PRICE_PLAN_GROUP_REQUEST,
    shoppingCartType,
    transfereeOfBrn
  }),
  success: (data) => ({ type: PRICE_PLAN_GROUP_SUCCESS, data }),
  failure: (error) => ({ type: PRICE_PLAN_GROUP_ERROR, error })
};

export const getPricePlanAssociation = {
  request: (requestData) => ({
    type: PRICE_PLAN_ASSOCIATION_REQUEST,
    requestData
  }),
  success: (data) => ({ type: PRICE_PLAN_ASSOCIATION_SUCCESS, data }),
  failure: (error) => ({ type: PRICE_PLAN_ASSOCIATION_ERROR, error })
};

export const getMobileShareLines = {
  request: () => ({ type: GET_MOBILE_SHARE_REQUEST }),
  success: (data) => ({ type: GET_MOBILE_SHARE_SUCCESS, data }),
  failure: (error) => ({ type: GET_MOBILE_SHARE_ERROR, error })
};

export const getMobileShareEligibility = {
  request: (requestData) => ({
    type: GET_MOBILE_SHARE_ELIGIBILITY_REQUEST,
    requestData
  }),
  success: (data) => ({ type: GET_MOBILE_SHARE_ELIGIBILITY_SUCCESS, data }),
  failure: (error) => ({ type: GET_MOBILE_SHARE_ELIGIBILITY_ERROR, error })
};

export const getAddonGroup = {
  request: (reqData) => ({
    type: ADDON_GROUP_REQUEST,
    reqData
  }),
  success: (data) => ({ type: ADDON_GROUP_SUCCESS, data }),
  failure: (error) => ({ type: ADDON_GROUP_ERROR, error })
};

export const getEquipmentDetails = {
  request: (deviceType, modelCode, brandDescription, earlyRecontractDetails): IgetEquipmentDetails => ({
    type: EQUIPMENT_DETAILS_REQUEST,
    deviceType,
    modelCode,
    brandDescription,
    earlyRecontractDetails
  }),
  success: (data, colorList, storageList) => ({
    type: EQUIPMENT_DETAILS_SUCCESS,
    data,
    colorList,
    storageList
  }),
  failure: (error) => ({ type: EQUIPMENT_DETAILS_FAILURE, error })
};

export const getServiceNumber = {
  request: (requestData) => ({
    type: SERVICE_NUMBER_REQUEST,
    requestData
  }),
  success: (data, pagination) => ({
    type: SERVICE_NUMBER_SUCCESS,
    data,
    pagination
  }),
  failure: (error) => ({ type: SERVICE_NUMBER_FAILURE, error })
};

export const getDeviceBrands = {
  request: () => ({ type: DEVICE_BRANDS_REQUEST }),
  success: (data) => ({ type: DEVICE_BRANDS_SUCCESS, data }),
  failure: (error) => ({ type: DEVICE_BRANDS_ERROR, error })
};

export const getDeviceByPlanGroup = {
  request: (page: number, size: number, reqData): DevicePlanGroupRequest => ({
    type: GET_DEVICES_BY_PLAN_GROUP_REQUEST,
    page: page,
    size: size,
    reqData
  }),
  success: (data) => ({ type: GET_DEVICES_BY_PLAN_GROUP_SUCCESS, data }),
  failure: (error) => ({ type: GET_DEVICES_BY_PLAN_GROUP_ERROR, error })
};

export const getSmartTemplateListDetails = {
  request: (reqData) => ({
    type: GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST,
    reqData
  }),
  success: (data) => ({ type: GET_SMART_TEMPLATE_LIST_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: GET_SMART_TEMPLATE_LIST_DETAILS_FAILURE, error })
};

export const getSmartTemplates = {
  request: () => ({ type: GET_SMART_TEMPLATE_MENU_REQUEST }),
  success: (data) => ({ type: GET_SMART_TEMPLATE_MENU_SUCCESS, data }),
  failure: (error) => ({ type: GET_SMART_TEMPLATE_MENU_FAILURE, error })
};

export const updateSmartTemplateName = {
  request: (reqData): IUpdateSmartTemplateName => ({ type: UPDATE_SMART_TEMPLATE_NAME_REQUEST, reqData }),
  success: (data) => ({ type: UPDATE_SMART_TEMPLATE_NAME_SUCCESS, data }),
  failure: (error) => ({ type: UPDATE_SMART_TEMPLATE_NAME_FAILURE, error })
};

export const deleteSmartTemplate = {
  request: (templateId): IDeleteSmartTemplate => ({ type: DELETE_SMART_TEMPLATE_REQUEST, templateId }),
  success: (data) => ({ type: DELETE_SMART_TEMPLATE_SUCCESS, data }),
  failure: (error) => ({ type: DELETE_SMART_TEMPLATE_FAILURE, error })
};

export const getCheckReserve = {
  request: () => ({ type: GET_CHECK_RESERVE_REQUEST }),
  success: (data) => ({ type: GET_CHECK_RESERVE_SUCCESS, data }),
  failure: (error) => ({ type: GET_CHECK_RESERVE_FAILURE, error })
};

export const getReservedStocksByModel = {
  request: (reqData) => ({ type: GET_RESERVED_STOCKS_REQUEST, reqData }),
  success: (data) => ({ type: GET_RESERVED_STOCKS_SUCCESS, data }),
  failure: (error) => ({ type: GET_RESERVED_STOCKS_FAILURE, error })
};

export const getSmartTemplateById = {
  request: (templateId) => ({ type: GET_SMART_TEMPLATE_BY_ID_REQUEST, templateId }),
  success: (data) => ({ type: GET_SMART_TEMPLATE_BY_ID_SUCCESS, data }),
  failure: (error) => ({ type: GET_SMART_TEMPLATE_BY_ID_FAILURE, error })
};

export const getBillingAccForNumberPool = {
  request: (payload) => ({ type: GET_NUMBER_POOL_BILL_ACC_REQUEST, payload }),
  success: (data) => ({ type: GET_NUMBER_POOL_BILL_ACC_SUCCESS, data }),
  failure: (error) => ({ type: GET_NUMBER_POOL_BILL_ACC_FAILURE, error })
};

export const getCheckoutBillAccNumberPool = {
  request: (payload) => ({ type: GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST, payload }),
  success: (data) => ({ type: GET_CHECKOUT_NUMBER_POOL_BILL_ACC_SUCCESS, data }),
  failure: (error) => ({ type: GET_CHECKOUT_NUMBER_POOL_BILL_ACC_FAILURE, error })
};

export const getNumberPoolBillAccount = {
  request: (billNo) => ({
    type: GET_NUMBER_POOL_EXISTING_BILL_ACCOUNT,
    billNo
  })
};

export const getBundledAddonsForPriceplan = {
  request: (data) => ({
    type: GET_BUNDLEDADDONS_FOR_PRICEPLAN_REQUEST,
    data
  }),
  success: (data) => ({ type: GET_BUNDLEDADDONS_FOR_PRICEPLAN_SUCCESS, data }),
  failure: (error) => ({ type: GET_BUNDLEDADDONS_FOR_PRICEPLAN_ERROR, error })
};

export const selectedPlan = (plan: IPlan) => ({
  type: SELECTED_PLAN,
  plan
});

export const getDepResellerBrn = {
  request: () => ({
    type:GET_DEP_RESELLER_ID_REQUEST
  }),
  success: (data) => ({ type: GET_DEP_RESELLER_ID_SUCCESS, data }),
  failure: (error) => ({ type: GET_DEP_RESELLER_ID_ERROR, error })
}